/**
 * @fileoverview Componente responsável por criar e editar cargos da empresa ativa.
 */

import React, { useEffect, useState } from "react";
import {
  Dialog,
  TextField,
  Typography,
  IconButton,
  makeStyles
} from "@material-ui/core";
import { Pencil, Plus, X } from "lucide-react";
import { i18n } from "../../translate/i18n";
import { createModalDesign } from "../../styles/modalDesign";

const useStyles = makeStyles((theme) => ({
  ...createModalDesign(theme),
}));

const JobRoleModal = ({ open, onClose, onSubmit, initialData, loading }) => {
  const classes = useStyles();
  const [name, setName] = useState("");
  const isEdit = !!initialData?.id;

  useEffect(() => {
    if (open) {
      setName(initialData?.name || "");
    }
  }, [open, initialData]);

  const handleSubmit = () => {
    onSubmit({ name });
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && !loading && name.trim()) {
      event.preventDefault();
      handleSubmit();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className={classes.mdDialog}
      maxWidth={false}
    >
      <div className={classes.mdHeader}>
        <Typography className={classes.mdTitle}>
          {isEdit
            ? i18n.t("settings.jobRoles.modal.edit")
            : i18n.t("settings.jobRoles.modal.add")}
        </Typography>
        <IconButton size="small" onClick={onClose} className={classes.mdCloseBtn}>
          <X size={18} strokeWidth={1.75} />
        </IconButton>
      </div>

      <div className={classes.mdContent}>
        <TextField
          label={i18n.t("settings.jobRoles.form.name")}
          variant="outlined"
          value={name}
          onChange={(event) => setName(event.target.value)}
          onKeyDown={handleKeyDown}
          fullWidth
          autoFocus
          className={classes.mdField}
        />
      </div>

      <div className={classes.mdActions}>
        <button
          type="button"
          onClick={onClose}
          disabled={loading}
          className={classes.mdBtnGhost}
        >
          {i18n.t("settings.jobRoles.buttons.cancel")}
        </button>
        <button
          type="button"
          onClick={handleSubmit}
          disabled={loading || !name.trim()}
          className={classes.mdBtnPrimary}
        >
          {isEdit ? (
            <Pencil size={15} strokeWidth={1.75} />
          ) : (
            <Plus size={15} strokeWidth={1.75} />
          )}
          {i18n.t("settings.jobRoles.buttons.save")}
        </button>
      </div>
    </Dialog>
  );
};

export default JobRoleModal;
